import { useSignPageControl } from '../use-sign-page-control';
import SignIn from './in';
import SignUp from './up';
import Tabs from '@/components/comm/tabs';
import Tab from '@/components/comm/tabs/Tab';
import { colors } from '@/constants/colors';

export type SignTabCode = (
  | 'in'
  | 'up'
  | 'find'
  | 'notuser'
  | 'alreadyuser'
);

const tabPosition = Object.freeze<Record<SignTabCode, number>>({
  in: 0,
  up: 1,
  find: 1,
  notuser: 1,
  alreadyuser: 1,
});

const SignTab = () => {

  const { push, tabCodePage } = useSignPageControl();

  const handleOnChange = (index: number) => {
    if (index === tabPosition.up) {
      push('find');
    } else {
      push('in');
    }
  };

  return (
    <Tabs
      index={tabCodePage ? tabPosition[tabCodePage] : tabPosition.in}
      onChange={handleOnChange}
      headStyle={{
        height: '52px',
        borderRadius: '15px 15px 0 0',
        textColor: colors.grey2,
        selectedBackgroundColor: colors.white,
        selectedBorderBottomThick: 0,
      }}
    >
      <Tab
        breakpointSmallLeftRightPadding="0"
        tabIndex={tabPosition.in}
        tabTitle="로그인"
      ><SignIn />
      </Tab>
      <Tab
        breakpointSmallLeftRightPadding="0"
        tabIndex={tabPosition.up}
        tabTitle="회원가입"
      ><SignUp />
      </Tab>
    </Tabs>
  );
};

export default SignTab;
